import { Button } from "../ui/button"

interface ActionButtonsProps {
  selectedGame: string
  tableData: any[]
  onBuy: () => void
  onClear: () => void
  onCancel: () => void
  onSingleResult?: () => void
  onSingleReport?: () => void
  isAdmin?: boolean
  loading?: boolean
  totalBets?: number
  totalAmount?: number
}

export function ActionButtons({
  selectedGame,
  tableData,
  onBuy,
  onClear,
  onCancel,
  onSingleResult,
  onSingleReport,
  isAdmin = false,
  loading = false,
  totalBets = 0,
  totalAmount = 0
}: ActionButtonsProps) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 p-4 bg-gray-50 rounded-lg border">
      {/* Totals Display */}
      <div className="flex gap-6 text-sm font-semibold">
        <div className="text-blue-600">
          Total Bets: <span className="text-lg">{totalBets}</span>
        </div>
        <div className="text-green-600">
          Total Amount: <span className="text-lg">₹{totalAmount}</span>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 justify-center sm:justify-end">
        {/* Admin Buttons */}
        {isAdmin && (
          <>
            <Button
              onClick={onSingleResult}
              disabled={loading}
              className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded"
            >
              {loading ? "Processing..." : "Draw Results (Ctrl+H)"}
            </Button>
            <Button
              onClick={onSingleReport}
              disabled={loading}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded"
            >
              {loading ? "Generating..." : "View Report (Ctrl+R)"}
            </Button>
          </>
        )}

        {/* User Buttons */}
        <Button
          onClick={onBuy}
          disabled={loading || totalBets === 0}
          className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded font-semibold"
        >
          {loading ? "Placing Bets..." : `Buy (F4) - ₹${totalAmount}`}
        </Button>

        <Button
          onClick={onClear}
          disabled={loading}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          Clear (F6)
        </Button>

        <Button
          onClick={onCancel}
          disabled={loading}
          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
        >
          Cancel (F7)
        </Button>
      </div>
    </div>
  )
}